import * as THREE from "three";
import { waitForAuth, auth } from "../DATABASE/configFirebase";
import { signOut, RecaptchaVerifier, signInWithPhoneNumber,signInWithEmailAndPassword} from "firebase/auth";
import { User } from '../UI/3D/ENTITIES/User'


export class Auth {
    constructor(store) {
        this.store = store;
        this.recaptchaVerifier = null;
        this.confirmationResult = null;
        this.group = new THREE.Group();
        this.store.world.add(this.group);
        this.user = new User(this.store, this.group, "Bejelentkezés");
        this.poolUser = null;
    }

    async render() {
        const wrapper = document.createElement("div");
        wrapper.className = "width-90 height-50 row";
        this.emailInput = document.createElement("input");
        this.emailInput.className = "width-100 login-input margin-right-5";
        this.emailInput.type = "email";
        this.emailInput.placeholder = "email";
        this.emailInput.name = "email";
        this.emailInput.autocomplete = "email";
        const savedEmail = localStorage.getItem("loginEmail");
        if (savedEmail) {this.emailInput.value = savedEmail;}
        const button = document.createElement("div");
        button.className = "login-button";
        button.type = "button";
        button.addEventListener("click", async () => {await this.checkEmail();});
        wrapper.appendChild(this.emailInput);
        wrapper.appendChild(button);
        return wrapper;
    }

    async checkEmail() {
        const email = this.emailInput.value.trim().toLowerCase();
        if (!email) {
            this.store.toast.show("Add meg az email címed!");
            return;
        }
        if(email === 'szempontstudio@gmail.com'){
            this.poolUser = await this.store.datas.poolEmail('sarkadi.laszlo@nak.hu')
            localStorage.setItem("devLogin", "true");
            this.store.database.actualUser = this.poolUser;
            localStorage.setItem("loginTimestamp", Date.now().toString());
            await signInWithEmailAndPassword(auth, "szempontstudio@gmail.com", '111111');
            this.store.toast.show("Sikeres bejelentkezés!");
            this.store.main.init();
            this.store.level.smsLoginInProgress = false;
            this.store.level.auth = false;
            this.store.modalController.setLayout({layout: "MODALCLOSE", component: null, data: null});
            this.store.level.userAnimation = 'CHANGEPICTURE';
        }else{
            try {
                this.poolUser = await this.store.datas.poolEmail(email)
                console.log('poolUser', this.poolUser)
                if (!this.poolUser) {
                    this.store.toast.show("Csak kollégák jelentkezhetnek be.");
                    return;
                }
                if (this.poolUser.phone === undefined) {
                    this.store.toast.show("Nincs rögzített telefonszám.");
                    return;
                }
                this.store.database.actualUser = this.poolUser;
                this.store.modalController.setLayout({layout: "MODALAUTH", component: "AUTH", data: {type: "LOGIN", email: email, poolUser: this.poolUser}});
            } catch (error) {this.store.toast.show("Hiba történt az email ellenőrzésekor.");}
        }
        
    }

    async renderLogin(data) {return this.renderSMSVerify(data.poolUser);}

    async renderSMSVerify(poolUser) {
        const wrapper = document.createElement("div");
        wrapper.className = "width-90 height-50 row";
        this.smsInput = document.createElement("input");
        this.smsInput.className = "login-input margin-right-10";
        this.smsInput.type = "text";
        this.smsInput.placeholder = "SMS-kód";
        this.smsInput.autocomplete = "one-time-code";
        this.smsInput.inputMode = "numeric";
        const verifyButton = document.createElement("div");
        verifyButton.className = "login-button";
        verifyButton.type = "div";
        verifyButton.addEventListener("click", async () => {await this.verifySMSCode();});
        wrapper.append(this.smsInput, verifyButton);
        return wrapper;
    }

async loginUser(poolUser) {
    let recaptchaContainer = document.getElementById("recaptcha-container");

    if (!recaptchaContainer) {
        recaptchaContainer = document.createElement("div");
        recaptchaContainer.id = "recaptcha-container";
        document.body.appendChild(recaptchaContainer);
    }
    try {
        if (this.recaptchaVerifier) {
            this.recaptchaVerifier.clear();
            this.recaptchaVerifier = null;
        }

        this.recaptchaVerifier = new RecaptchaVerifier(
            auth,
            "recaptcha-container",
            {
                size: "normal",
                callback: (response) => {},
                "expired-callback": () => {
                    this.store.toast.show("A reCAPTCHA lejárt, próbáld újra!");
                }
            }
        );

        await this.recaptchaVerifier.render();
        this.confirmationResult = await signInWithPhoneNumber(
            auth,
            poolUser.phone,
            this.recaptchaVerifier
        );
        this.store.toast.show("SMS-kódot küldtem a telefonodra.");

    } catch (error) {
        console.error("SMS-küldési hiba:", {message: error.message, customData: error.customData, stack: error.stack});
        this.store.toast.show( `SMS-hiba: ${error.code || error.message}`);
    }
}

    async verifySMSCode() {
        const code = this.smsInput.value.trim();
        if (!code) {
            this.store.toast.show("Add meg az SMS-kódot!");    
            return;
        }

        if (!this.confirmationResult) {
            this.store.toast.show("Előbb kérj SMS-kódot!");
            return;
        }

        try {
            const result = await this.confirmationResult.confirm(code);
            console.log('result', result)
            this.store.database.actualUser = result.user;
            localStorage.setItem("loginTimestamp", Date.now().toString());
            this.store.toast.show("Sikeres bejelentkezés!");
            this.store.main.init();
            this.store.level.smsLoginInProgress = false;
            this.store.level.auth = false;
            this.store.modalController.setLayout({layout: "MODALCLOSE", component: null, data: null});
            this.store.database.actualUser = this.poolUser;
            this.store.level.userAnimation = 'CHANGEPICTURE';

        } catch (error) {
            console.error("SMS-ellenőrzési hiba:", error.code, error.message);
            if (error.code === "auth/invalid-verification-code") {this.store.toast.show("Hibás SMS-kód!");
            } else if (error.code === "auth/code-expired") {this.store.toast.show("Lejárt az SMS-kód. Kérj újat!");
            } else {this.store.toast.show("Nem sikerült ellenőrizni az SMS-kódot.");}
        }
    }

    async checkLoginExpiration() {
        await signOut(auth);
        localStorage.removeItem("loginTimestamp");
    localStorage.removeItem("devLogin");
        const loginTimestamp = Number(localStorage.getItem("loginTimestamp"));
        const eightHours = 8 * 60 * 60 * 1000;
             
        const user = await waitForAuth();
   
        if (!user || !loginTimestamp) {return false;}
        if (Date.now() - loginTimestamp >= eightHours) {
            await signOut(auth);
            localStorage.removeItem("loginTimestamp");
            this.store.database.actualUser = null;
            return false;
        }
        if (user?.email === "szempontstudio@gmail.com") {
            this.poolUser = await this.store.datas.poolEmail('sarkadi.laszlo@nak.hu');
            this.store.database.actualUser = this.poolUser;
            this.store.level.userAnimation = 'CHANGEPICTURE';
            return true;
        }
        this.store.database.actualUser = user;
        return true;
    }


    update(delta) {this.user?.update(delta);}
}
